import { render } from "./HotspotsCarousel.vue?vue&type=template&id=781ebf46&scoped=true"
import script from "./HotspotsCarousel.vue?vue&type=script&lang=js"
export * from "./HotspotsCarousel.vue?vue&type=script&lang=js"

import "./HotspotsCarousel.vue?vue&type=style&index=0&id=781ebf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781ebf46"]])

export default __exports__